import { Controller } from "@hotwired/stimulus"

// Handles sticky day headers behavior for flat_feed_v3 (similar to Instagram)
export default class extends Controller {
  initialize() {
    this.lastScrollTop = 0
    this.headerShownAfterInitialLoad = false
  }

  connect() {
    // Add the flat-feed-v3-page-body class to the body for scroll behavior
    document.body.classList.add("flat-feed-v3-page-body")
    
    // Initialize scroll direction detection
    this.initializeScrollDetection()
  }

  disconnect() {
    // Clean up scroll detection
    this.cleanupScrollDetection()
    document.body.classList.remove("flat-feed-v3-page-body")
  }

  initializeScrollDetection() {
    this.scrollHandler = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.scrollHandler, { passive: true })
  }

  cleanupScrollDetection() {
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler)
      this.scrollHandler = null
    }
  }

  handleScroll() {
    let currentScroll = window.scrollY || document.documentElement.scrollTop
    this.headerShownAfterInitialLoad = true
    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll // Prevent negative values
  }
}

